import { render } from "./SuccessfulPaymentNotification.vue?vue&type=template&id=4720da32&scoped=true"
import script from "./SuccessfulPaymentNotification.vue?vue&type=script&lang=js"
export * from "./SuccessfulPaymentNotification.vue?vue&type=script&lang=js"

import "./SuccessfulPaymentNotification.vue?vue&type=style&index=0&id=4720da32&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4720da32"]])

export default __exports__